import * as React from "react";
import {KeyValue} from "./Form";
import {FormUtils} from "./FormUtils";
import {AbstractInputElement, FormElement} from "./FormInput";
import * as _ from "lodash";


interface State {
    range?: string
}

export interface RangeProps extends FormElement<string, HTMLInputElement> {
    from?: string;
    to?: string;
    className?: string;
}

export class RangeInput extends AbstractInputElement<string, RangeProps, State> {
    validationName = "range";

    constructor(props) {
        super(props);
        this.state = {range: this.getRangeFromProps(props)};
    }

    componentDidMount() {
        var from = this.props.fieldSet.getModelValue(this.props.from);
        var to = this.props.fieldSet.getModelValue(this.props.to);
        var validationError = null;
        if (!from) {
            from = 0;
        }
        if (!to) {
            to = 0;
        }
        if (from == 0 || to == 0 || to < from) {
            validationError = "rangeError";
        }
        var validationResult = {errorName: validationError, pristine: true};
        console.log("setting initial value " + this.props.from, from);
        this.props.fieldSet.setInitialModel(this.props.to, to, true, validationResult);
        this.props.fieldSet.setInitialModel(this.props.from, from, true, validationResult);
    }

    getDefaultValue() {
        return "";
    }

    getRangeFromProps(props: RangeProps) {
        var from = this.props.fieldSet.getModelValue(this.props.from);
        var to = this.props.fieldSet.getModelValue(this.props.to);
        if (to && from) {
            return from + (from != to ? "-" + to : "");
        }
        return "";
    }

    onChange(range: string) {
        var range = "" + range;
        this.setState({range: range});
        if (range && range.match(/^[0-9]{1,10}(\-[0-9]{1,10})?$/) != null) {
            var from = 0, to = 0;
            var split = range.split("-");
            if (split.length == 2) {
                from = parseInt(split[0]);
                to = parseInt(split[1]);
            } else {
                from = parseInt(split[0]);
                to = from;
            }
            this.updateModel(from, to, false);
        } else {
            this.updateModel(0, 0, false);
        }
    }

    updateModel(from, to, pristine) {
        var validationError = null;
        if (from == 0 || to == 0 || to < from) {
            validationError = "rangeError";
        }

        var validationResult = {errorName: validationError, pristine: pristine};
        this.props.fieldSet.updateModels([
            new KeyValue(this.props.to, to, pristine, validationResult),
            new KeyValue(this.props.from, from, pristine, validationResult)
        ]);
    }

    getClassNames() {
        var valid = this.props.fieldSet.isModelValid(this.validationName);
        return FormUtils.getClassName(this.props.className, "error", valid);
    }

    render() {
        let rest = _.omit(this.props, ['validators', `model`, `fieldSet`, `modelValue`, `valid`, 'validationMap']);
        return <input {...rest} className={this.getClassNames()} value={this.state.range}
                      onChange={this.handleChange.bind(this)}/>
    }

}






// WEBPACK FOOTER //
// ./src/app/ui/form/RangeInput.tsx